import { appConfig } from '../config/appConfig';

export const ApiRepos = `${appConfig.apiBaseUrl}/`;
